import { formatMoney } from 'accounting'
import isMobileBrowser from 'is-mobile'

import { Box, DashboardModule, StatusBadge } from '@domain-group/suit-theme'

import {
  faAddressBook, faCircleDollar, faUser,
} from '@fortawesome/pro-light-svg-icons'

import { statusColors } from '@functions/status'

import { InvoiceModel } from '@models/invoice'

import InvoiceDetail from './InvoiceDetail'

interface InvoiceInfoPanelProps {
  invoice: InvoiceModel,
}

const InvoiceInfoPanel = (props: InvoiceInfoPanelProps) => {
  const {
    invoice: {
      approved, debtor_name, order_title, total,
    },
  } = props

  const isMobile = isMobileBrowser()
  const invoiceStatus = approved ? 'approved' : 'pending'

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: ['column', 'row'] }}
      title="Invoice Details"
    >
      <InvoiceDetail
        boxProps={{ flex: 1 }}
        icon={faUser}
        title="Contact"
        value={debtor_name}
      />

      <InvoiceDetail
        boxProps={{ flex: 2 }}
        icon={faAddressBook}
        title="Recipient Address"
        value={order_title}
      />

      <Box flex={1}>
        <InvoiceDetail
          // @ts-expect-error TS2322
          boxProps={isMobile && {
            borderRight: '1px solid',
          }}
          icon={faCircleDollar}
          title="Price"
          value={formatMoney(total)}
        />

        <InvoiceDetail
          boxProps={{ borderBottom: 'none', borderRight: 'none' }}
          title="Status"
        >
          <StatusBadge
            color={statusColors[invoiceStatus]}
            ghost
            text={invoiceStatus}
          />
        </InvoiceDetail>
      </Box>
    </DashboardModule>
  )
}

export default InvoiceInfoPanel
